
import { SearchOutlined } from '@ant-design/icons';
import {  Checkbox, Empty, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TdsFormItem } from '@/presentation/components/tds-form';
import {
  COLUMN_GROUP_INFO,
  FORM_EXCEPTION_INFORMATION,
} from '@/presentation/components/tds-form/tds-fields-filter/config';
import { TdsColumnGroup } from '../type';


export interface IFilterArrayProps {
  entries?: TdsFormItem[];
  defaultSelectedEntries: TdsFormItem[];
  onSelectedChange?: (entries: TdsFormItem[]) => void;
  renderByGroup?: boolean;
}

export const FilterArray = (props: IFilterArrayProps) => {
  const { t } = useTranslation();
  const { entries = [], defaultSelectedEntries = [], onSelectedChange } = props;
  const [selectedEntries, setSelectedEntries] = useState<TdsFormItem[]>(defaultSelectedEntries);
  const [search, setSearch] = useState<string>('');
  const [selectAllChecked, setSelectAllChecked] = useState(selectedEntries.length >= entries.length);

  const isChecked = (entry: TdsFormItem) => selectedEntries
    .some((curEntry: TdsFormItem) => entry.name === curEntry.name);

  const indeterminate = selectedEntries.length > 0 && selectedEntries.length < entries.length;

  const handleSelectAllChange = (e: CheckboxChangeEvent) => {
    const { checked } = e.target;
    setSelectAllChecked(checked);
    const tempSelectedEntries = checked ? entries : [];
    setSelectedEntries?.(tempSelectedEntries);
    onSelectedChange?.(tempSelectedEntries);
  };

  // 异常信息
  const exceptionInformationList = useMemo(
    () => {
      const exceptionList = entries
        ?.filter((item) => {
          const label = item.labelString || (typeof (item.label) === 'string' ? item.label : '') || '';
          return FORM_EXCEPTION_INFORMATION.includes(label) && label.indexOf(search || '') > -1;
        });
      const otherList = entries
        ?.filter((item) => {
          const label = item.labelString || (typeof (item.label) === 'string' ? item.label : '') || '';
          return (!FORM_EXCEPTION_INFORMATION.includes(label))
              && (label).indexOf(search || '') > -1;
        }) || [];
      return exceptionList?.concat(otherList) || [];
    },
    [entries, search],
  );


  const onClick = (entry: TdsFormItem, checked: boolean) => {
    const tempSelectedEntries = [...selectedEntries];
    if (checked) {
      tempSelectedEntries.push(entry);
    } else {
      const filterIndex = tempSelectedEntries.findIndex((curFilter: TdsFormItem) => entry.name === curFilter.name);
      if (filterIndex !== -1) {
        tempSelectedEntries.splice(filterIndex, 1);
      }
    }
    setSelectAllChecked(tempSelectedEntries.length >= entries.length);
    setSelectedEntries(tempSelectedEntries);
    onSelectedChange?.(tempSelectedEntries);
  };

  const searchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const renderColumnGroup = () => {
    if (isEmpty(exceptionInformationList)) return <Empty description={t('暂无数据')} />;

    const groups = Object.keys(COLUMN_GROUP_INFO);

    return (
      <div>
        {groups.map((group) => {
          const currentGroup = COLUMN_GROUP_INFO[group as TdsColumnGroup];
          const groupColumn = exceptionInformationList.filter((column: TdsFormItem) => column.group === group);

          if (isEmpty(groupColumn)) return null;

          return (
            <div className='mb-[16px]'>
              <div className='text-xs mb-[4px]'>{currentGroup.title}</div>
              <div className={'flex gap-[8px] flex-wrap'}>{groupColumn.map((item, index) => {
                const isSelect = isChecked(item);
                return <div key={index} onClick={() => onClick(item, !isSelect)} className={
                classnames({
                  ['text-[12px] px-[8px] py-[2px] rounded-[2px] cursor-pointer']: true,
                  ['text-[#4A5970] bg-[#EDF1F7]']: !isSelect,
                  ['text-[#FFF] bg-[#0A6CFF]']: isSelect,
                })}>{item?.labelString || item?.label}</div>;
              })}</div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderColumns = () => (exceptionInformationList?.length
    ? <div className={'flex gap-[8px] flex-wrap pb-[12px]'}>{exceptionInformationList.map((item, index) => {
      const isSelect = isChecked(item);
      return <div key={index} onClick={() => onClick(item, !isSelect)} className={
          classnames({
            ['text-[12px] px-[8px] py-[2px] rounded-[2px] cursor-pointer']: true,
            ['text-[#4A5970] bg-[#EDF1F7]']: !isSelect,
            ['text-[#FFF] bg-[#0A6CFF]']: isSelect,
          })}>{item?.labelString || item?.label}</div>;
    })}</div> : <Empty description={t('暂无数据')} />);

  return <div className={'flex flex-col px-[12px]'} style={props.renderByGroup ? { width: 588 } : { width: 300 }}>
    <div className='mb-[8px]'>
      <Input value={search} onChange={searchChange} placeholder={t('搜索字段')} suffix={<SearchOutlined />} />
    </div>
    {props.renderByGroup ? renderColumnGroup() : renderColumns()}
    <div className={'pt-[8px] border-t border-[#EDF1F7] border-solid flex justify-between'}>
      {!search ? <Checkbox
        checked={selectAllChecked}
        onChange={handleSelectAllChange}
        indeterminate={indeterminate}
      >{t('全选')}</Checkbox> : <div/>}
    </div>
  </div>;
};
